import BaseWidget from "common/widgets/base/BaseWidget";
import locale from "common/managers/locale";
import "common/bindings/field";
import "common/bindings/action";
import OperationMixin from "common/framework/OperationMixin";
import classes from "app/css/widgets/DFButton.module.less";

var DFButton = BaseWidget(kendo.ui.Button).extend(OperationMixin).extend({

    loader: null,

    options: {
        name: "DFButton",
        tooltip: false,
        loadingClass: "fa fa-spinner fa-spin",

        // the locale key to use for the aria-label when the button action is in progress
        loadingLabelKey: "loading.progress",

        // the text to use as the aria-label when the button action is in progress, this takes precedence over they key above
        loadingLabel: null,

        //Locale entry to display in tooltip when this button is disabled
        disabledMessage: false,
        // buttons are hidden in readonly mode
        readonly: false,

        confirm: false, //When true, confirmation buttons are show inline when the button is clicked before events are fired
        confirmMessage: "confirm", //confirmation message
        confirmYes: "yes",
        confirmNo: "cancel"
    },

    init: function(el, options) {
        const $el = $(el);
        if($el.hasClass("add")) {
            $el.addClass(classes.add);
            options.spriteCssClass = classes.addIcon;
        } else if($el.hasClass("delete")) {
            options.spriteCssClass = classes.deleteIcon;
        } else if($el.hasClass("refreshButton")) {
            $el.addClass(classes.refresh);
            options.spriteCssClass = classes.refreshIcon;
            options.tooltip = "refresh";
        }
        kendo.ui.Button.fn.init.call(this, el, options);
        if(this.element.hasClass("sub")) {
            this.element.addClass(classes.sub);
        }
        this.element.addClass("dfButton").addClass(classes.DFButton);
        this._tooltip();
    },

    /**
     * Override
     * Support resetting tooltip
     */
    setOptions() {
        kendo.ui.Button.fn.setOptions.apply(this, arguments);
        this._tooltip();
    },

    /**
     * Assign the button tooltip if one is defined
     * @private
     */
    _tooltip() {
        if(this.options.tooltip) {
            this.element.attr("title", locale.get(this.options.tooltip));
        }
    },

    focus: function() {
        this.element.focus();
    },

    _spinnerInProgress: false,

    _hideSpinner: function() {
        var me = this;
        me._spinnerInProgress = false;
        this._setLoadingLabel(false);
        var text = me.element.find(".buttonDisplay");
        text.stop().animate({
            opacity: 1
        }, 100, function() {
            if (me.loader != null) {
                $(me.loader).remove();
                me.loader = null;
            }
            $(text).contents().unwrap();
        });
    },

    _showSpinner: function() {
        var me = this;
        me._spinnerInProgress = true;
        this._setLoadingLabel(true);
        var text = me.element.find(".buttonDisplay");
        if (text.length == 0) {
            var wrap = $("<span>").addClass("buttonDisplay");
            me.element.wrapInner(wrap);
            return me._showSpinner();
        }
        text.stop().animate({
            opacity: 0
        }, 100, function() {
            if (me.loader == null) {
                me.loader = $("<span>").addClass("buttonLoader").addClass(classes.buttonLoader).addClass(me.options.loadingClass);
                me.loader.attr("id", me.element.attr("id") + "_spinner");
                me.element.append(me.loader);
            }
        });
    },

    _setLoadingLabel: function(isLoading) {
        if (!this.options.loadingLabel && !this.options.loadingLabelKey) {
            return;
        }
        if (isLoading === true) {
            this.element.attr("aria-label", this.options.loadingLabel || locale.get(this.options.loadingLabelKey));
            return;
        }
        this.element.removeAttr("aria-label");
    },

    /**
     * The button widget will hide or show a spinner based off of the value.  Accepts three types of values
     *
     * True = add, show, and animate spinner
     * False = stop animation, hide, and remove spinner
     * Promise = show spinner, hide spinner once promise resolves
     * @param val
     */
    value: function(val) {
        if (val !== undefined) {
            this.startNewOp();
            if (val === true) {
                this._showSpinner();
                delete this._valuePromise;
            } else if (val === false) {
                this._hideSpinner();
                delete this._valuePromise;
            } else {
                this._showSpinner();
                this.handleValuePromise(val);
            }
        }
    },

    /**
     * Only act on the last promise value
     * @param val
     */
    handleValuePromise(val) {
        this._valuePromise = $.when(val);
        this._valuePromise.always(this.ifOp(() => {
            this._hideSpinner();
            delete this._valuePromise;
        }));
    },

    /**
     * Set the confirmation state.  This just adjusts the confirm option.
     * @param val
     * @returns {boolean} confirm option
     */
    confirm: function(val) {
        if (val !== undefined) {
            this.options.confirm = val ? true : false;
            if (!this.options.confirm) {
                this.resetConfirm();
            }
        }
        return this.options.confirm;
    },

    /**
     * Determine if widget is in a confirming state.
     * @returns {boolean} true if in confirming state
     */
    confirming: function() {
        return this.options.confirming ? true : false;
    },

    _click: function() {
        if (this._spinnerInProgress) {
            return;
        } else if (this.options.confirm && this.options.enable && !this.confirmWrapper) {
            this._showConfirm();
        } else {
            kendo.ui.Button.fn._click.apply(this, arguments);
        }
    },

    _showConfirm: function() {
        var me = this;
        var wrapper = $("<div>")
            .addClass("inlineConfirm")
            .append($("<span>").text(locale.get(this.options.confirmMessage)))
            .insertAfter(this.element);
        this.element.hide();
        this.confirmWrapper = wrapper;
        var yes = $("<button>")
            .attr("id", this.element.attr("id") + "_yes")
            .addClass("primary")
            .text(locale.get(this.options.confirmYes))
            .appendTo(wrapper);
        this.confirmYesBtn = new DFButton(yes, {
            click: function() {
                me.element.focus();
                me.element.click();
                me.resetConfirm();
            }
        });
        var no = $("<button>")
            .attr("id", this.element.attr("id") + "_no")
            .addClass("secondary")
            .text(locale.get(this.options.confirmNo))
            .appendTo(wrapper);
        this.confirmNoBtn = new DFButton(no, {
            click: function() {
                me.resetConfirm();
                me.element.focus();
                me.trigger("cancel");
            }
        });
        this.options.confirming = true;
        this.trigger("confirmingChange");

        yes.focus();
    },

    onHide: function() {
        this.resetConfirm();
    },

    enable: function(enable) {
        if (this.confirmNoBtn) {
            this.confirmNoBtn.enable(enable);
        }
        if (this.confirmYesBtn) {
            this.confirmYesBtn.enable(enable);
        }

        if (enable && this.options.disabledMessage) {
            this.element.removeAttr("title").removeAttr("alt");
        } else if (!enable && this.options.disabledMessage) {
            var m = locale.get(this.options.disabledMessage);
            this.element.attr("title", m).attr("alt", m);
        }

        kendo.ui.Button.fn.enable.apply(this, arguments);
    },

    readonly: function(to) {
        this.options.readonly = to;
        if (to) {
            this.element.hide();
        } else {
            this.element.show();
        }
    },

    /**
     * If button is in confirm state, reset to normal state.
     */
    resetConfirm: function() {
        if (this.confirmWrapper) {
            this.element.show();
            this.confirmWrapper.remove();
            delete this.confirmWrapper;
            delete this.confirmNoBtn;
            delete this.confirmYesBtn;
            this.options.confirming = false;
            this.trigger("confirmingChange");
        }
    }
});
kendo.ui.plugin(DFButton);
export default DFButton;
